









































import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator';
import { putMap, postMap } from '@/service/project-management/map';
import {
    fetchDeviceList,
} from "@/service/project-management/device-management";
import {
    syncMap,
    getSyncMapRes,
} from "@/service/project-management/map";
import { Getter } from 'vuex-class';
import InfiniteScrollList from '@/components/InfiniteScrollList'
import { sleep } from '@/util'

const CHECK_SYNC_RESULT_INTERVAL = 3000
const CHECK_SYNC_RESULT_NUM = 40

@Component({
    components: {
        InfiniteScrollList,
    },
})
export default class SyncMapDialog extends Vue {
    dialogVisible: boolean = true;
    dialogLoading: boolean = false;
    pageSet = {
        pageNo: 0,
        pageSize: 20,
    }
    listDataSource = [];
    listLoading = false;
    listDisabled = false;
    deviceSelected: string | null = null;
    syncSuccess = false;

    @Getter('pm/projectID')
    projectID;

    @Emit('close')
    handleCancel() {
        this.dialogVisible = false;
    }

    beforeDestroy() {
        this.syncAbort && this.syncAbort()
        this.syncSuccess = true
    }

    async handleSubmit() {
        if (!this.deviceSelected) {
            this.$message.warning('请选择机器人')
            return
        }

        try {
            await this.$confirm(
                '同步后，将清空地点列表，同时将新地图数据同步至列表中',
                `确认同步?`,
                {
                    customClass: 'rop-confirm-box',
                    cancelButtonClass: 'rop-btn size-dialog light',
                    confirmButtonClass: 'rop-btn size-dialog dark',
                },
            );
        } catch (err) {
            return;
        }

        let newMap = []
        this.dialogLoading = true
        this.syncSuccess = false
        const param = {
            deviceId: this.deviceSelected
        }
        try {
            await syncMap(param)
            let checkNum = 0
            while (this.syncSuccess === false) {
                checkNum++
                const data = await getSyncMapRes(param)
                if (data && data.length > 0) {
                    this.syncSuccess = true
                    newMap = data
                } else if (checkNum > CHECK_SYNC_RESULT_NUM) {
                    this.$message.error('地图同步失败，请检查机器人')
                    break
                } else{
                    const { promise, abort } = sleep(CHECK_SYNC_RESULT_INTERVAL)
                    this.syncAbort = abort
                    await promise
                }
            }
            if (this.syncSuccess) {
                this.$message.success('成功同步地图')
                this.$emit('submit', {
                    deviceId: param.deviceId,
                    mapData: newMap,
                });
            }
        } catch (e) {

        }
        this.dialogLoading = false
    }

    async fetchDeviceList() {
        this.listLoading = true
        this.listDisabled = true
        const requestParams = {
            ...this.pageSet,
            projectId: this.projectID,
        };
        try {
            const {
                content,
                totalPages,
            } = await fetchDeviceList(requestParams)
            this.listLoading = false
            if (_.isArray(content)) {
                this.listDataSource.push(...content)
            }
            if (totalPages === this.pageSet.pageNo + 1) {
                return
            }
        } catch (e) {
            this.listLoading = false
            this.$message.error(e.message)
        }
        this.pageSet.pageNo++
        this.listDisabled = false
    }

}
